import { ReactComponent as AddItemIcon } from "../assets/icon_add.svg";
import { ReactComponent as ArrowRightIcon } from "../assets/icon_arrow_right.svg";
import { ReactComponent as RemoveItemIcon } from "../assets/icon_remove.svg";
import { ReactComponent as EditItemIcon } from "../assets/icon_edit.svg";
import { ReactComponent as ViewItemIcon } from "../assets/icon_view.svg";
import { ReactComponent as SortAscAlphaIcon } from "../assets/icon_sort_asc_alpha.svg";
import { ReactComponent as SortDescAlphaIcon } from "../assets/icon_sort_desc_alpha.svg";
import { ReactComponent as EmployeeIcon } from "../assets/icon_employee.svg";
import { ReactComponent as CustomerIcon } from "../assets/icon_customer.svg";
import { ReactComponent as VendorIcon } from "../assets/icon_vendor.svg";
import { ReactComponent as ShipmentIcon } from "../assets/icon_shipment.svg";
import { ReactComponent as GoBackIcon } from "../assets/icon_go_back.svg";
import { ReactComponent as LegacyDataIcon } from "../assets/icon_legacy.svg";
import { ReactComponent as TrailerIcon } from "../assets/icon_trailer.svg";
import { ReactComponent as LoadIcon } from "../assets/icon_load.svg";
import { ReactComponent as WarningIcon } from "../assets/icon_warning.svg";
import { ReactComponent as QrIcon } from "../assets/icon_qr.svg";
import { ReactComponent as UpIcon } from "../assets/icon_up.svg";
import { ReactComponent as DownIcon } from "../assets/icon_down.svg";

export namespace Icons {

	export const AddItem = ({ ...props }) => {
		return (
			<AddItemIcon fill={props.fill} height={props.height}></AddItemIcon>
		)
	}

	export const ArrowRight = ({ ...props }) => {
		return (
			<ArrowRightIcon fill={props.fill} height={props.height} style={{ transform: `rotate(${props.rotate ?? "0deg"})` }} className={props.className}></ArrowRightIcon>
		)
	}

	export const RemoveItem = ({ ...props }) => {
		return (
			<RemoveItemIcon fill={props.fill} height={props.height}></RemoveItemIcon>
		)
	}

	export const EditItem = ({ ...props }) => {
		return (
			<EditItemIcon fill={props.fill} height={props.height}></EditItemIcon>
		)
	}

	export const ViewItem = ({ ...props }) => {
		return (
			<ViewItemIcon fill={props.fill} height={props.height}></ViewItemIcon>
		)
	}

	export const SortAscAlpha = ({ ...props }) => {
		return (
			<SortAscAlphaIcon fill={props.fill} height={props.height}></SortAscAlphaIcon>
		)
	}

	export const SortDescAlpha = ({ ...props }) => {
		return (
			<SortDescAlphaIcon fill={props.fill} height={props.height}></SortDescAlphaIcon>
		)
	}

	export const Employee = ({ ...props }) => {
		return (
			<EmployeeIcon fill={props.fill} height={props.height}></EmployeeIcon>
		)
	}

	export const Customer = ({ ...props }) => {
		return (
			<CustomerIcon fill={props.fill} height={props.height}></CustomerIcon>
		)
	}

	export const Vendor = ({ ...props }) => {
		return (
			<VendorIcon fill={props.fill} height={props.height}></VendorIcon>
		)
	}

	export const Shipment = ({ ...props }) => {
		return (
			<ShipmentIcon fill={props.fill} height={props.height}></ShipmentIcon>
		)
	}

	export const GoBack = ({ ...props }) => {
		return (
			<GoBackIcon fill={props.fill} height={props.height}></GoBackIcon>
		)
	}

	export const LegacyData = ({ ...props }) => {
		return (
			<LegacyDataIcon fill={props.fill} height={props.height}></LegacyDataIcon>
		)
	}

	export const Trailer = ({ ...props }) => {
		return (
			<TrailerIcon fill={props.fill} height={props.height}></TrailerIcon>
		)
	}

	export const Load = ({ ...props }) => {
		return (
			<LoadIcon fill={props.fill} height={props.height}></LoadIcon>
		)
	}

	export const Warning = ({ ...props }) => {
		return (
			<WarningIcon fill={props.fill} height={props.height}></WarningIcon>
		)
	}

	export const QrCode = ({ ...props }) => {
		return (
			<QrIcon fill={props.fill} height={props.height}></QrIcon>
		)
	}

	export const Up = ({ ...props }) => {
		return (
			<UpIcon fill={props.fill} height={props.height}></UpIcon>
		)
	}

	export const Down = ({ ...props }) => {
		return (
			<DownIcon fill={props.fill} height={props.height}></DownIcon>
		)
	}

}